import React from 'react';

import { L10n } from '../../components/L10n';
import Typography from '../../components/Typography';
import Link from '../../components/Link';

const shinglesDisclaimer = {
  disclaimer: (
    <Typography variant={['textVariant']}>
      <L10n tokenID="disclaimer.shingles" />
    </Typography>
  ),
  disclaimerChecked: false,
};

const covidDisclaimer = {
  disclaimer: (
    <Typography variant={['textVariant']}>
      <L10n tokenID="disclaimer.covid_1" />
      <Link href="https://www.cdc.gov/covid/risk-factors/index.html" external>
        <L10n tokenID="disclaimer.covid_link" />
      </Link>
      <L10n tokenID="disclaimer.covid_2" />
    </Typography>
  ),
  disclaimerChecked: false,
};

export const disclaimerSpecs = () => ({
  shingles: shinglesDisclaimer,
  'COVID-19': covidDisclaimer,
});
